import React from 'react';

interface Props {
  text: string;
  status: string;
}

const getStatusClassName = (status: string) => status.toLowerCase().replace(/_/g, '-');

const TaskStatus: React.FC<Props> = ({ text, status }) => (
  <div className={`badge-base task-status task-status--${getStatusClassName(status)}`}>
    <div className="badge-text">
      <span>{text}</span>
    </div>
  </div>
  // <div className="task-status-wrapper">
  //   <span className={`task-status task-status--${getStatusClassName(status)}`}>{text}</span>
  // </div>
);

export default TaskStatus;
